import { render, staticRenderFns } from "./RingChart2.vue?vue&type=template&id=402cee7b&scoped=true&"
import script from "./RingChart2.vue?vue&type=script&lang=js&"
export * from "./RingChart2.vue?vue&type=script&lang=js&"
import style0 from "./RingChart2.vue?vue&type=style&index=0&id=402cee7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402cee7b",
  null
  
)

export default component.exports